import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {ENABLED_FEATURES} from '../../../../constants';
import {useGetAccessManagementFeaturesQuery} from '../../../../queries';
import {API_FEATURE_ICON, SINGLE_COLUMN_LAYOUT, TWO_COLUMNS_LAYOUT} from '../../constants';
import {DataSharingFeature} from '../../types';
import {useShareAccessFeatureFlag} from 'presentation/pages/private/hooks/useShareAccessFeatureFlag';

export function useDataSharingFeatures() {
	const {isEnabled: isShareAccessEnabled} = useShareAccessFeatureFlag();
	const {isEnabled: isFeaturesApiEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_SHARE_ACCESS_FEATURES_API,
	);

	const {
		data: featuresData,
		isFetching: isFetchingFeatures,
		isError,
	} = useGetAccessManagementFeaturesQuery({
		enabled: isShareAccessEnabled && isFeaturesApiEnabled,
	});

	const apiFeatures: DataSharingFeature[] = (featuresData?.funcionalidades ?? []).map(
		feature => ({
			key: feature.dsChaveFuncionalidade,
			iconName: API_FEATURE_ICON,
			title: feature.nmFuncionalidade,
			description: feature.dsFuncionalidade,
		}),
	);

	const features: DataSharingFeature[] =
		isFeaturesApiEnabled && !isError ? apiFeatures : ENABLED_FEATURES;

	const layout = isFeaturesApiEnabled ? TWO_COLUMNS_LAYOUT : SINGLE_COLUMN_LAYOUT;

	return {
		isShareAccessEnabled,
		isFeaturesApiEnabled,
		isFetchingFeatures,
		features,
		layout,
	};
}
